var _circle, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.98 437.02c-99.974-99.975-99.974-262.065 0-362.04-.007.011 147.629 181.02 147.629 181.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m222.609 256-188.656-127.487c-5.849 10.167-11.007 20.779-15.439 31.763l95.509 95.725-95.506 95.73c4.428 10.976 9.581 21.581 15.426 31.741z",
    fill: "#ffda44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m509.833 222.609h-287.231l-147.624-147.625c-15.908 15.908-29.729 33.899-41.025 53.53l127.239 127.486-127.249 127.47c11.296 19.636 25.123 37.633 41.035 53.545l147.624-147.624h287.231c1.423-10.93 2.167-22.074 2.167-33.391s-.744-22.461-2.167-33.391z",
    fill: "#6da544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m100.138 459.077c43.169 33.182 97.206 52.923 155.862 52.923 118.279 0 217.805-80.221 247.181-189.217h-266.748z",
    fill: "#0052b4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m503.181 189.217c-29.376-108.996-128.902-189.217-247.181-189.217-58.656 0-112.693 19.741-155.862 52.923l136.294 136.294z",
    fill: "#d80027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/southAfrica.72b88660d0537b662175732662ac681f.svg";
export { ForwardRef as ReactComponent };